import { zodResolver } from '@hookform/resolvers/zod';
import { Form, FormField } from '@repo/shadcn';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

import { OrdersAutoComplete } from './orders-autocomplete';
import { SalesReturnOrder } from './sales-return-order';

const SelectOrderSchema = z.object({
    order_id: z.string(),
});

export const SalesReturnModal = () => {
    const form = useForm<z.infer<typeof SelectOrderSchema>>({
        mode: 'onChange',
        resolver: zodResolver(SelectOrderSchema),
    });
    const { watch } = form;

    const orderId = watch('order_id');

    return (
        <div className="">
            <div className="flex items-center justify-between gap-4 px-4 py-2">
                <h3 className="font-bold">Sales Return</h3>
                <div className="grow">
                    <Form {...form}>
                        <form>
                            <FormField
                                control={form.control}
                                name="order_id"
                                render={({ field }) => (
                                    <OrdersAutoComplete
                                        control={form.control}
                                        name={field.name}
                                    />
                                )}
                            />
                        </form>
                    </Form>
                </div>
            </div>
            <SalesReturnOrder orderId={orderId} />
        </div>
    );
};
